import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { BuilderContext } from '../../../store/store.Builder'

import styles from './HeaderCanvas.module.css'

const HeaderCanvas = observer(() => {
  const builderContext = useContext(BuilderContext)
  return (
    <div className={styles.header__editor_canvas}>
      <div
        className={styles.btn__state__sidebarFields}
        onClick={builderContext.toggleSidebarFields}
      >
        <Button
          icon={
            builderContext.isSidebarFieldsOpen ? (
              <MenuFoldOutlined />
            ) : (
              <MenuUnfoldOutlined />
            )
          }
        />
      </div>
      <div
        className={styles.btn__state__sidebarEditor}
        onClick={builderContext.toggleSidebarEditor}
      >
        <Button
          icon={
            builderContext.isSidebarEditorOpen ? (
              <MenuUnfoldOutlined />
            ) : (
              <MenuFoldOutlined />
            )
          }
        />
      </div>
    </div>
  )
})
export default HeaderCanvas
